export default {"src":"/_next/static/media/link_your_bank_now.81528fe0.svg","height":244,"width":366,"blurWidth":0,"blurHeight":0};